import React from "react";

import { Notification } from "@/types/Notification";
import NotificationView from "./Notification";

import { useDispatch } from "react-redux";
import { removeNotification } from "@/redux/reducer/notificationSlice";

interface NotificationPanelProps {
  notifications: Notification[];
}

const NotificationPanel: React.FC<NotificationPanelProps> = ({
  notifications,
}) => {
  const [removing, setRemoving] = React.useState<number[]>([]);
  const dispatch = useDispatch();

  const handleRemoveNotification = (id: number) => {
    setRemoving((prevRemoving) => [...prevRemoving, id]);
    setTimeout(() => {
      setRemoving((prevRemoving) => prevRemoving.filter((item) => item !== id));
      dispatch(removeNotification({ id }));
    }, 500);
  };

  return (
    <div className="fixed top-24 ltr:right-3 rtl:left-3 space-y-2 z-9999">
      {notifications.map((notification) => (
        <div
          data-id={notification.id}
          key={notification.id}
          className={`notification-container 
            ${
              removing.includes(notification.id)
                ? "animate-slide-out"
                : "animate-slide-in"
            } `}
        >
          <NotificationView
            notification={notification}
            onClose={(id) => handleRemoveNotification(id)}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationPanel;
